export default [
	{
		path: '/order/confirm/:id',
		name: 'OrderConfirm',
		component: () => import('@/views/order/confirm.vue'),
		meta: { title: '订单确认' }
	},
	{
		path: '/order/record/:id',
		name: 'OrderRecord',
		component: () => import('@/views/order/record.vue'),
		meta: { title: '订单记录' }
	},
	{
		path: '/order/chat',
		name: 'OrderChat',
		component: () => import('@/views/order/chat.vue'),
		meta: { title: '咨询订单' }
	},
	{
		path: '/order/chatDetail/:id',
		name: 'OrderChatDetail',
		component: () => import('@/views/order/chatDetail.vue'),
		meta: { title: '订单详情' }
	},
	{
		path: '/order/detail/:id',
		name: 'OrderDetail',
		component: () => import('@/views/order/detail.vue'),
		meta: { title: '订单详情' }
	}
]
